import BadgeComponent from './Badge.jsx'
import PanelComponent from './Panel.jsx'
import { SAFE_DEFAULTS, resolveConfig } from './constants.js'
import { detect as detectPure } from './detect.js'
import { render } from './renderer.js'
import { toUtcSeconds } from '@/utils/utcTime'

export const defaultConfig = SAFE_DEFAULTS

export { resolveConfig }

function gatedResult() {
  return { mas: [], gated: true }
}

function sanitizeCandles(candles) {
  if (!Array.isArray(candles)) return null
  const out = []
  for (const c of candles) {
    if (c == null || typeof c !== 'object') continue
    const open = c.open
    const high = c.high
    const low = c.low
    const close = c.close
    if (open == null || high == null || low == null || close == null) continue
    const openNum = Number(open)
    const highNum = Number(high)
    const lowNum = Number(low)
    const closeNum = Number(close)
    if (!Number.isFinite(openNum) || !Number.isFinite(highNum) || !Number.isFinite(lowNum) || !Number.isFinite(closeNum)) continue
    const time = toUtcSeconds(c.time)
    if (time == null) continue
    out.push({ time, open: openNum, high: highNum, low: lowNum, close: closeNum, volume: Number.isFinite(Number(c.volume)) ? Number(c.volume) : 0 })
  }
  return out
}

export function detect(candles, rawConfig) {
  try {
    const cfg = resolveConfig(rawConfig)
    if (cfg.enabled === false) return null
    const clean = sanitizeCandles(candles)
    if (!clean || clean.length === 0) return null
    return detectPure(clean, cfg)
  } catch {
    return null
  }
}

export default {
  id: 'ema_sma_quantum',
  name: 'EMA / SMA',
  version: '1.0.0',
  defaultConfig,
  detect,
  render,
  BadgeComponent,
  PanelComponent,
  renderOnPan: false,
}
